export default function getApiRoot() {
  return `${((process.env.REACT_APP_PERSONAL_INFORMATIONS_MOCK_API === 'true') ?
    '/api' :
    process.env.REACT_APP_PERSONAL_INFORMATIONS_API_ROOT) ?? '/api'}/omni/profile/v2`;
}
